function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.59 2.44H2.53v3.061",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.59 2.44H2.53v3.061l3.06-3.06z",
  stroke: "#12002D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 9.971h3.06v-3.06",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 9.971h3.06v-3.06L7 9.97z",
  stroke: "#12002D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 8.91l-5.5-5.5",
  stroke: "#12002D",
  strokeWidth: "1.5"
})));